<template>
  <b-container fluid
               id="esg-partner-monitoring">
    <esg-base-card title="협력사 정보"
                   :footer="false">
      <template #actions>
        <b-col cols="12">
          <b-input-group class="mr-2">
            <b-form-input placeholder="협력사 검색"
                          readonly
                          v-model="partner.name"></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-secondary"
                        v-b-modal.product-family-search>
                <b-icon icon="search"></b-icon>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </template>

      <!-- No data -->
      <esg-base-dashboard-card v-show="false"
                               title="제품군을 선택해주세요">
        <b-row align-h="center">
          <b-col cols="6"
                 class="align-self-center">
            <b-img class="mx-auto"
                   height="500px"
                   fluid
                   alt="no data"
                   src="https://img.freepik.com/free-vector/no-data-concept-illustration_114360-536.jpg?w=1060&t=st=1689857913~exp=1689858513~hmac=1e495cb440fd330d72a6dcc5c0780a9207f8b4355a148e33effa35f06717678b"/>
          </b-col>
        </b-row>
      </esg-base-dashboard-card>
      <!-- No data -->

      <esg-base-dashboard-card>
        <template #title>
          <!-- 왼쪽에 위치할 객체 -->
          <div class="d-flex flex-column">
              <span class="mr-2"
                    style="font-size: 1.4rem; font-weight: bold">{{ partner.name }}</span>
            <span>관리 번호: {{ partner.code }}</span>
            <span>주거래 사업장: {{ partner.main_business_location }}</span>
          </div>
        </template>
        <template #actions>
          <div class="d-flex align-items-center mr-2">
            <button type="button"
                    class="status-item">
              <span class="status">제출완료</span>
            </button>
          </div>

          <div class="d-flex flex-column">
            <b-form-row>
              <span style="font-size : 0.8em;"><b>요청일자:</b> 2023-08-31 </span>
            </b-form-row>
            <b-form-row>
              <span style="font-size : 0.8em;"><b>마감일자:</b> 2023-08-31 </span>
            </b-form-row>
            <b-form-row>
              <span style="font-size : 0.8em;"><b>제출일자:</b> 2023-08-31 </span>
            </b-form-row>
          </div>
        </template>

        <b-container fluid
                     id="esg-individual-partner-monitoring"
                     class="mt-2">
          <b-row align-h="start"
                 align-v="center"
                 class="mb-1">
            <b-col md="6"
                   lg="2"
                   class="mt-1 mt-lg-0">
              <esg-single-score-card title="총배출량"
                                     :score="1275"
                                     score-unit="tCO2e"
                                     diff-unit="%"
                                     labelColor="blue"/>
            </b-col>
            <b-col md="6"
                   lg="2"
                   class="mt-3 mt-lg-0">
              <esg-single-score-card title="온실가스 배출비중"
                                     :score="6.4"
                                     score-unit="%"
                                     labelColor="blue"/>
            </b-col>
            <b-col md="6"
                   lg="1"
                   class="mt-3 mt-lg-0"/>
            <b-col md="6"
                   lg="2"
                   class="mt-3 mt-lg-0">
              <esg-single-score-card title="업스트림 배출량"
                                     :score="1275"
                                     score-unit="tCO2e"
                                     labelColor="blue"/>
            </b-col>
            <b-col md="6"
                   lg="2"
                   class="mt-3 mt-lg-0">
              <esg-single-score-card title="다운스트림 배출량"
                                     :score="0"
                                     score-unit="tCO2e"
                                     labelColor="blue"/>
            </b-col>
            <b-col md="6"
                   lg="1"
                   class="mt-3 mt-lg-0"/>
            <b-col md="6"
                   lg="2"
                   class="mt-3 mt-lg-0">
              <esg-single-score-card title="배출량 순위"
                                     score="35/249"
                                     labelColor="red"/>
            </b-col>
          </b-row>

          <!-- Charts -->
          <b-row>
            <b-col lg="6">
              <esg-partner-emission-share class="chart"/>
            </b-col>
            <b-col lg="6"
                   class="mt-3 mt-lg-0">
              <esg-partner-evaluation-matrix class="chart"/>
            </b-col>
          </b-row>
          <!-- Charts -->
          <b-row>
            <b-col class="mt-3 mt-lg-0">
              <esg-partner-data-grid/>
            </b-col>
          </b-row>
        </b-container>
      </esg-base-dashboard-card>
    </esg-base-card>
  </b-container>
</template>

<script>
import EsgSingleScoreCard from "@/components/esg/base/EsgSingleScoreCard.vue";
import EsgCardHeader from "@/components/esg/base/EsgBaseCardHeader.vue";
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import EsgPartnerDataGrid from "../3.4.4. 배출량관리/EsgPartnerDataGrid.vue";
import EsgPartnerEmissionShare from "./EsgPartnerEmissionShare.vue";
import EsgPartnerEvaluationMatrix from "./EsgPartnerEvaluationMatrix.vue";
import EsgBaseCard from "@/components/esg/base/EsgBaseCard.vue";

export default {
  components: {
    EsgBaseCard,
    EsgPartnerDataGrid,
    EsgBaseDashboardCard,
    EsgPartnerEvaluationMatrix,
    EsgPartnerEmissionShare,
    EsgCardHeader,
    EsgSingleScoreCard
  },
  props: {},
  watch: {},
  computed: {},
  data() {
    return {
      partner: {
        name: 'EY 정공',
        code: '2022-001',
        main_business_location: '울산 고무 공장',
        total_emission: 1234,
        share: 6.4,
        upstream_emission: 1234,
        downstream_emission: 0,
        rank: 35,
      }
    }
  },
  methods: {}
}
</script>

<style scoped>

#esg-individual-partner-monitoring .wrap {
  padding: 0 !important;
  margin-top: 1em;
  margin-bottom: 1em;
}

#esg-individual-partner-monitoring .card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

#esg-individual-partner-monitoring >>> .chart .card-body {
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#esg-individual-partner-monitoring .table-wrapper {
  width: 100%
}

#esg-partner-monitoring .status-item {
  align-items: center;
  justify-content: space-between;
  gap: 0 10px;
  text-align: center;
  min-width: 18%;
  height: 75%;
  border-radius: 9px;
  border: none;

  background-color: #CFDDFF;
  color: #1755CC;
  font-size: 14px;
  margin-bottom: 0.5em;
  font-weight: bold;
}


#esg-partner-monitoring .status {
  font-weight: bold;
  line-height: 150%;
}

#esg-partner-monitoring .card-body .card {
  border: 1px solid lightgray;
  margin-top: 1em;

}

#esg-partner-monitoring .card-body .card-header {
  padding-left: 1em;
}

#esg-partner-monitoring .card-body .card-body {
  padding: 0.5em;
}

</style>